module.exports = __webpack_public_path__ + "images/emoji/high_brightness.adca0f3000289f6dfb51.png";